module.exports = __webpack_public_path__ + "static/media/menu-card-1.fcfdba23.jpg";